import { render } from "./preMoneyModel.vue?vue&type=template&id=20c4b5c6"
import script from "./preMoneyModel.vue?vue&type=script&lang=js"
export * from "./preMoneyModel.vue?vue&type=script&lang=js"

import "./preMoneyModel.vue?vue&type=style&index=0&id=20c4b5c6&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__